import { useState } from 'react';
import { getFlagImageSrc, getLanguageOption } from '../../utils/languages';

const FlagIcon = ({ code, className = '' }) => {
  const lang = getLanguageOption(code);
  const [failed, setFailed] = useState(false);

  if (failed) {
    return (
      <span
        aria-hidden="true"
        className={`inline-block h-[13px] w-[18px] shrink-0 rounded-[2px] bg-[#3d8ef0]/35 ${className}`.trim()}
      />
    );
  }

  return (
    <img
      src={getFlagImageSrc(lang.code)}
      alt=""
      width={18}
      height={13}
      draggable={false}
      aria-hidden="true"
      className={`np-flag-img inline-block h-[13px] w-[18px] shrink-0 rounded-[2px] object-cover shadow-[0_0_0_1px_rgba(255,255,255,0.16)] ${className}`.trim()}
      onError={() => setFailed(true)}
    />
  );
};

export default FlagIcon;
